const { REACT_APP_API_ENV = "dev" } = process.env;

/** CDN 翻译资源基础路径（含翻译包 ID）；pro 走线上，其余走测试 */
const TRANSLATE_CDN_BASE =
	  (REACT_APP_API_ENV === 'dev' ||
  REACT_APP_API_ENV === 'qa')
		? "https://hdl-crm-test-sg-bucket.superhi-cdn.com/operator/translate/87"
		:  "https://crm-prod.superhi-cdn.com/operator/translate/6";

/** 业务 languageCode -> CDN locale 文件名 */
const LANGUAGE_CODE_TO_LOCALE_FILE: Record<string, string> = {
	CN: "cn",
	EN: "en",
	VN: "vi",
	JP: "ja",
	KR: "ko",
	TH: "th",
	ID: "id",
	FR: "fr",
	KM: "km",
	ES: "es",
	RU: "ru",
	AR: "ar",
};

const DEFAULT_LOCALE_FILE = "en";

/**
 * 将业务语言码映射为 CDN 上的 locale 文件名（不含 .json 后缀）
 * 例如 CN -> cn， zh-hk / zh-tw
 */
const getLocaleFileName = (languageCode: string): string => {
	if (languageCode === "HK-TW") {
		return "zh-tw";
	}
	if (languageCode === "ZH-HK") {
		return "zh-hk";
	}

	return LANGUAGE_CODE_TO_LOCALE_FILE[languageCode] ?? DEFAULT_LOCALE_FILE;
};

/** 拼接完整的 CDN 翻译 JSON 地址 */
const buildLocaleUrl = (languageCode: string) => {
	const localeFile = getLocaleFileName(languageCode);
	return `${TRANSLATE_CDN_BASE}/${localeFile}.json?t=${Date.now()}`;
};

/**
 * 从 CDN 异步加载指定语言的翻译文案
 * @param languageCode 业务语言码，如 CN / EN / HK-TW
 * @returns 中文 key -> 对应语言文案 的对象；请求失败时返回空对象，由页面按中文 key 兜底
 */
export const fetchTranslate = async (
	languageCode: string,
): Promise<Record<string, string>> => {
	const url = buildLocaleUrl(languageCode);
	const res = await fetch(url);
	if (!res.ok) {
		return {};
	}

	return res.json();
};

/**
 * 替换模板字符串中的占位符，如 "重新获取 ({SECONDS})" -> "重新获取 (60)"
 * @param str 含 {key} 占位符的字符串
 * @param obj 占位符 key 与替换值的映射
 */
export function templateReplace(str: string, obj: any) {
	return str.replace(/\{(\w+)\}/g, (match, key) => {
		return Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : match;
	});
}
